import { render, staticRenderFns } from "./LeftContent.vue?vue&type=template&id=08247426&scoped=true"
import script from "./LeftContent.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftContent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LeftContent.vue?vue&type=style&index=0&id=08247426&prod&lang=less&scoped=true"
import style1 from "./LeftContent.vue?vue&type=style&index=1&id=08247426&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08247426",
  null
  
)

export default component.exports